export type MediaNivel = 'MASTER' | 'ESTADO' | 'MUNICIPIO' | 'ESCOLA';
export type MediaLayout = 'TEXTO_SIMPLES' | 'IMAGEM_DESTAQUE' | 'VIDEO_BACKGROUND';
export type MediaTipo = 'NOTICIA' | 'ENQUETE' | 'DESTAQUE_PESSOA' | 'COMUNICADO' | 'PATROCINADO' | 'SISTEMA';

/** Configuração do botão de ação (CTA) — opcional por item */
export interface MediaAcaoBotao {
  texto: string;          // Ex: 'PARTICIPAR', 'SAIBA MAIS', 'INSCREVA-SE', 'DOAR'
  icone?: 'heart' | 'bookmark' | 'share' | 'link' | 'megaphone' | 'star' | 'gift';
  cor?: string;           // Cor de fundo (default: verde)
  url?: string;           // Link externo opcional
}

export interface AcMediaItem {
  id: string;
  tipo: MediaTipo;
  layout: MediaLayout;
  titulo: string;
  subtitulo?: string;
  resumo?: string;
  imageUrl?: string;
  videoUrl?: string;
  fonte: string;
  nivel: MediaNivel;
  patrocinador?: string;
  acaoBotao?: MediaAcaoBotao;
  enquete?: {
    opcoes: { id: string; texto: string; votos: number }[];
    totalVotos: number;
  };
  duracaoSegundos: number;
}

export const MOCK_FEED: AcMediaItem[] = [
  {
    id: '1',
    tipo: 'NOTICIA',
    layout: 'IMAGEM_DESTAQUE',
    titulo: 'MEC anuncia repasses do Fundeb para 2026',
    resumo: 'Novos valores visam a modernização das escolas e compra de equipamentos tecnológicos.',
    fonte: 'Ministério da Educação',
    nivel: 'MASTER',
    imageUrl: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&q=80&w=1200',
    duracaoSegundos: 10,
    acaoBotao: { texto: 'SAIBA MAIS', icone: 'link', cor: '#3b82f6' }
  },
  {
    id: '2',
    tipo: 'PATROCINADO',
    layout: 'VIDEO_BACKGROUND',
    titulo: 'Feira do Livro 2026',
    subtitulo: 'Descontos de até 50% para Professores',
    resumo: 'A maior feira da américa latina agora em versão digital. Cadastre-se e ganhe um e-book.',
    fonte: 'Editora Nacional',
    nivel: 'MASTER',
    patrocinador: 'Editora Nacional',
    imageUrl: 'https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&q=80&w=1200',
    duracaoSegundos: 12,
    acaoBotao: { texto: 'INSCREVA-SE', icone: 'gift', cor: '#8b5cf6' }
  },
  {
    id: '3',
    tipo: 'ENQUETE',
    layout: 'TEXTO_SIMPLES',
    titulo: 'Consulta: Novo Horário de Recreio',
    subtitulo: 'Gestão Escolar',
    resumo: 'Qual a sua opinião sobre dividir o recreio em 3 turnos para diminuir a lotação no pátio?',
    fonte: 'Diretoria Escola Municipal XYZ',
    nivel: 'ESCOLA',
    duracaoSegundos: 15,
    enquete: {
      opcoes: [
        { id: 'o1', texto: 'Totalmente a favor', votos: 120 },
        { id: 'o2', texto: 'Acho ruim', votos: 45 },
        { id: 'o3', texto: 'Indiferente', votos: 12 },
      ],
      totalVotos: 177
    },
    acaoBotao: { texto: 'VOTAR', icone: 'star', cor: '#f59e0b' }
  },
  {
    id: '4',
    tipo: 'COMUNICADO',
    layout: 'IMAGEM_DESTAQUE',
    titulo: 'Feriado Municipal: Sexta-Feira sem aulas',
    resumo: 'Informamos que devido ao aniversário da cidade, não haverá expediente.',
    fonte: 'Prefeitura',
    nivel: 'MUNICIPIO',
    imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=1200',
    duracaoSegundos: 8
  },
  {
    id: '5',
    tipo: 'DESTAQUE_PESSOA',
    layout: 'IMAGEM_DESTAQUE',
    titulo: 'Professora Maria Vence Prêmio de Inovação',
    subtitulo: 'Projeto de Robótica com Sucata',
    resumo: 'Nossa professora de Ciências foi reconhecida na premiação estadual de Inovação Escolar!',
    fonte: 'Governo do Estado',
    nivel: 'ESTADO',
    imageUrl: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?auto=format&fit=crop&q=80&w=1200',
    duracaoSegundos: 12,
    acaoBotao: { texto: 'PARTICIPAR', icone: 'heart', cor: '#10b981' }
  }
];

export const MOCK_SLOTS_CONFIG = [
  { nivel: 'MASTER', nome: 'Espaço Nacional (MEC, Global Ads)', peso: 30, conteudos: ['1', '2'] },
  { nivel: 'ESTADO', nome: 'Espaço Estadual (Secretaria, Governo)', peso: 20, conteudos: ['5'] },
  { nivel: 'MUNICIPIO', nome: 'Espaço Municipal (Prefeitura, Parceiros Locais)', peso: 20, conteudos: ['4'] },
  { nivel: 'ESCOLA', nome: 'Espaço Escolar (Agenda, Destaques, Enquetes)', peso: 30, conteudos: ['3'] },
];
